import { OreButton, OreStack, SvgDownload } from '@edenredespana/oreneta'
import { useTranslation } from 'react-i18next'

import { AutoEnrollmentDocumentModel } from '@/AutoEnrollment/domain'
import { AutoEnrollmentTranslation } from '@/AutoEnrollment/ui/autoEnrollmentTranslation'
import { edenredProducts, textToPdf } from '@/Shared/domain'

interface Step3GetProductDocumentProps {
  productId: edenredProducts
  documentsForSigning: AutoEnrollmentDocumentModel[]
}

export const Step3GetProductDocument = ({
  productId,
  documentsForSigning,
}: Step3GetProductDocumentProps): JSX.Element | null => {
  const { t } = useTranslation()
  const documentForProduct = documentsForSigning?.find(
    document => document.documentProduct === productId && document.documentType === 3,
  )

  if (documentForProduct) {
    return (
      <OreStack placeContent="end">
        <OreButton
          onClick={() => {
            textToPdf(
              documentForProduct.documentContent,
              documentForProduct.documentName.split('.').slice(0, -1).join('.'),
            )
          }}
          icon={<SvgDownload />}
        >
          {t(
            AutoEnrollmentTranslation.productsConditions.servicesTable.downloadButton
              .label,
          )}
        </OreButton>
      </OreStack>
    )
  }
  return null
}
